import React from 'react';
import './adminUi.css';

export function AdminStatCard(props: {
    label: string;
    value: React.ReactNode;
}) {
    return (
        <div className="adminStatCard">
            <span className="adminStatLabel">{props.label}</span>
            <strong className="adminStatValue">{props.value}</strong>
        </div>
    );
}